'use client';

import CaseGrid from '@/components/sections/cases/overview/case-grid/case-grid';
import Filter from '@/components/sections/cases/overview/filter/filter';
import { filterCasesBySelections } from '@/lib/filterCases';
import { Case, ServiceType } from '@/payload-types';
import { CaseTypeOption } from '@/payload/collections/Cases';
import { useMemo, useState } from 'react';

interface OverviewProps {
    cases: Case[];
    services: ServiceType[];
    questions: CaseTypeOption[];
}

export default function Overview({ cases, services }: OverviewProps) {
    const [selectedServices, setSelectedServices] = useState<ServiceType[]>([]);
    const [selectedQuestions] = useState<CaseTypeOption[]>([]);

    const filteredCases = useMemo(
        () =>
            filterCasesBySelections(cases, selectedServices, selectedQuestions),
        [cases, selectedServices, selectedQuestions],
    );

    return (
        <>
            <Filter
                services={services}
                selectedServices={selectedServices}
                setSelectedServices={setSelectedServices}
            />
            <CaseGrid cases={filteredCases} />
        </>
    );
}
